import createTableStore from "ds/components/Table/store/useTableStore";

import {
  SPACE_API_KEY_SESSIONS_COLUMN_CONFIG,
  SPACE_API_KEY_SESSIONS_COLUMNS_STORAGE_KEY,
} from "./constants";

const useSpaceDetailsApiKeySessionsTableStore = createTableStore({
  storageKey: SPACE_API_KEY_SESSIONS_COLUMNS_STORAGE_KEY,
  config: SPACE_API_KEY_SESSIONS_COLUMN_CONFIG,
});

export default useSpaceDetailsApiKeySessionsTableStore;
